/*
 * @Author: Vanny
 * @Date: 2019-09-05 11:28:36
 * @LastEditors: Vanny
 * @LastEditTime: 2020-05-27 16:11:17
 * @Description: 日报表管理 - 仓库
 */
import { call, put, select } from 'redux-saga/effects';
import { isEqual } from 'lodash';

import * as reportApi from '../../services/reportApi';
import { deepConvertCamel } from '../../tools';
import { pretreatReportConfig } from '@duoke/tools/umd/report';

const formatQuery = ({ views, precision, filters, sorts, needSummary, ...props }) => ({
  ...props,
  precision,
  queryParts: ['DATA'],
  views: views.filter(v => v.isSelected).map((v) => v.fieldKey),
  sorts: sorts.map((v) => ({ key: v.fieldKey, order: v.order })),
  filters: Object.keys(filters).reduce((acc, key) => {
    if (typeof filters[key] === 'object' && (filters[key] || {}).action === 'IN') {
      acc[key] = { ...filters[key], val: filters[key].val.map((v) => (v === -1 ? null : v)) };
    } else if (!['sday', 'eday', 'timeTab', 'timeType'].includes(key) && filters[key]) {
      acc[key] = filters[key];
    }
    return acc;
  }, {}),
});
const initialSingle = {
  loading: false, // 是否 Loading
  hasConfig: false, // 是否有 config， 减少请求次数
  source: {}, // 报表数据
  config: {
    info: {}, // 报表信息
    sorts: [], // 排序
    views: [], // 视图
    filters: [], // 筛选
    filterGroup: [], // 筛选存在的 key
    precisions: [], // 精度
    preciseSearch: [], // 精确搜索
  }, // 报表筛选配置
  query: {}, // 用户当前搜索条件
  custom: {}, // 用户自定义配置
  reqId: '',
};
const initialState = {};

const preTreatReportConfigV2 = (apiResult) => {
  const ret = pretreatReportConfig({ ...apiResult });
  return ret;
};

export const state = initialState;

export const effects = {
  // 获取配置项
  * fetchReportConfig({ payload }) {
    const { reportKey } = payload;
    yield put({ type: 'dailyReport/setTypeState', payload: { reportKey, loading: true } });
    const traceBox = { key: `pc-report-${reportKey}` };
    const custom = yield put.resolve({ type: 'app/fetchTraceBox', payload: traceBox });
    const res = yield call(reportApi.requestReportConfig, payload);
    if (res) {
      const [config] = preTreatReportConfigV2({ ...res.result });

      yield put({
        type: 'dailyReport/setTypeState',
        payload: {
          reportKey,
          custom: custom || { title: config?.info?.name || '' },
          config,
          hasConfig: true,
          loading: false,
        },
      });
    }
    return res?.result;
  },
  // 获取报表列表
  * fetchReportList({ payload }) {
    const { reportKey, page } = payload;

    yield put({ type: 'dailyReport/setTypeState', payload: { reportKey, loading: true } });

    const state = yield select(({ dailyReportState }) => dailyReportState);
    const { custom } = state[reportKey];
    const current = {
      ...custom,
      ...payload,
      page: { size: page.size }, // 每页条数
      views: payload.views.map(({ fieldKey, isSelected, fixed }) => ({
        fieldKey,
        isSelected,
        fixed,
      })),
    };

    if (!isEqual(custom, current)) {
      yield put({
        type: 'app/fetchUpdateTraceBox',
        payload: { key: `pc-report-${reportKey}`, value: current },
      });
      yield put({ type: 'dailyReport/setTypeState', payload: { reportKey, custom: current } });
    }
    const res = yield call(reportApi.requestReportList, formatQuery(payload));
    if (res) {
      const source = deepConvertCamel(res?.result);
      const page = source?.page || payload?.page || {};
      page.size = page.size || 80;
      page.startNo = page.startNo || 1;
      const len = source?.data?.length || 0;
      page.total =
        len < page.size ? (page.startNo - 1) * page.size + len : (page.startNo + 1) * page.size;

      yield put({
        type: 'dailyReport/setTypeState',
        payload: { reportKey, source: { ...source, page }, reqId: res.req_id },
      });
    }
    yield put({ type: 'dailyReport/setTypeState', payload: { reportKey, loading: false } });
  },
  // 导出Excel
  * fetchExportList({ payload }) {
    return yield call(reportApi.requestExportList, formatQuery(payload));
  },
};

export const reducers = {
  initState(state, { payload }) {
    return {
      ...payload.reduce((acc, v) => ((acc[v.key || v.id] = initialSingle), acc), {}),
      ...state,
    };
  },
  setTypeState(state, { payload }) {
    const { reportKey, ...props } = payload;
    return {
      ...state,
      [reportKey]: {
        ...state[reportKey],
        ...props,
      },
    };
  },
};
